import { controller, controllerAs, template } from 'modals/marketplaceRegister';

import tableHeaders from './tableHeaders';
/* global swal, moment */

import './style.less';
import { get } from 'lodash';

export default function(
  $log,
  $filter,
  ApiClass,
  $uibModalStack,
  $uibModal,
  Swal,
  ProfileClass,
  $stateParams,
  AuthClass,
  VendorClass
) {
  'ngInject';

  $log.debug('Bundles Component Activated');
  const vm = this;
  vm.$onChanges = activate;

  vm.pageTitle = 'Bundles';
  vm.tableHeaders = tableHeaders;
  vm.dataCollection = [];

  const loggedIn = ProfileClass.loggedIn;

  vm.sortBundles = () => {
    vm.bundles = $filter('orderBy')(vm.bundles, vm.sort);
  };

  vm.purchase = bundle => {
    if (bundle.status === 'registered') return;

    const vendor_id = get(bundle, 'vendor.vendor_id', bundle.vendor_id);

    if (!loggedIn) return AuthClass.authenticationPopup({ company_id: VendorClass.convertUser(vendor_id) }); //open login for not logged in users;

    $uibModalStack.dismissAll();
    $uibModal
      .open({
        backdrop: true,
        size: 'lg',
        template,
        controller,
        controllerAs,
        resolve: {
          bundle: () => bundle,
          event: () => false,
          adminRegistration: () => false,
          profileData: () => undefined,
          manage: () => false,
          loadContent: () => true
        }
      })
      .result.then(status => {
        if (status === 'registered') Swal.toast('Bundle purchased successful!');
        bundle.status = 'registered';
      });
  };

  function activate() {
    $log.debug('Bundles Component Updated');
    vm.loaded = false;

    ApiClass.productsGet(
      {},
      {},
      {
        queryParams: {
          'filters:type': 'bundles',
          'filters:vendor_id': $stateParams.vendor_id,
          'joins:passes': true
        }
      }
    )
      .then(({ data }) => {
        vm.sort = '+name';
        vm.bundles = data.products;
        vm.sortBundles();
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        $scope.loaded = true;
        $scope.error = { status: error.status, refresh: activate };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/marketplaceBundle/controller.js